import { triggerEvent } from './utilities/utilities';

const usercentricsEvents = (): void => {
    window.addEventListener('UC_UI_CMP_EVENT', ev => {
        if (ev.detail.type === 'SAVE') triggerEvent('ucControlled:saved');
        if (ev.detail.type === 'ACCEPT_ALL') triggerEvent('ucControlled:loaded');
        if (ev.detail.type === 'DENY_ALL') triggerEvent('ucControlled:denied');
    });
};

usercentricsEvents();
